/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Agent_Builder_Scope_Teams_CountInputs */



/**
* | output |
* | --- |
* | "{count} teams" |
*
* @param {Agent_Builder_Scope_Teams_CountInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_builder_scope_teams_count = /** @type {((inputs: Agent_Builder_Scope_Teams_CountInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Builder_Scope_Teams_CountInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.count} Teams`)
	return /** @type {LocalizedString} */ (`${i?.count} teams`)
});